import { Box, Typography, Stack, Grid } from "@mui/material";
import { QBCommandQueue } from "../components/qb-desktop/QBCommandQueue";
import { QBConnectionCard } from "../components/qb-desktop/QBConnectionCard";

/**
 * /qb-queue — observability surface for the QuickBooks Desktop pipeline.
 *
 * Shows:
 *   - QBConnectionCard  — last sync timestamp, QBWC bridge health, pause/
 *                         resume controls, force-retry-all, clear-failures.
 *   - QBCommandQueue    — every QBXML command ever enqueued, filterable by
 *                         status (queued / sent / completed / failed /
 *                         expired). Click a row to expand the full request
 *                         + response XML pair.
 *
 * This is the operator-facing audit trail for "what did the system actually
 * try to write to QB Desktop, and what did QB return."
 */
export function QBQueue() {
  return (
    <Box>
      <Stack spacing={1} sx={{ mb: 3 }} data-tour="page-title-qb-queue">
        <Typography variant="h4">QuickBooks Desktop — Command Queue</Typography>
        <Typography variant="body2" color="text.secondary">
          Every QBXML command the system enqueues, sends to QB Desktop via the
          QBWC bridge, and the response that came back. Click a row to expand
          the full request/response payloads. Use the controls in the
          connection card to pause new enqueues, force-retry failures, or
          clear permanently-failed rows.
        </Typography>
      </Stack>

      <Grid container spacing={3}>
        <Grid item xs={12} lg={4} data-tour="qb-connection-card">
          <QBConnectionCard isAdmin={true} />
        </Grid>
        <Grid item xs={12} lg={8} data-tour="qb-command-queue">
          <QBCommandQueue />
        </Grid>
      </Grid>
    </Box>
  );
}
